var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "view_column-24px_1_",
    "data-name": "view_column-24px (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3980",
    "data-name": "Path 3980",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3981",
    "data-name": "Path 3981",
    d: "M4,5V18H21V5ZM14,7v9H11V7ZM6,7H9v9H6Zm13,9H16V7h3Z",
    fill: "#7BC807"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortIcon);
export default __webpack_public_path__ + "static/media/table-sort-icon.116b3d80.svg";
export { ForwardRef as ReactComponent };